<template>
  <div class="header">
    <div class="header-top">
      <img class="header-logo desktop" src="../../assets/img/logo.svg" alt="AE" />
      <img class="header-logo mobile" src="../../assets/img/login/logo.svg" alt="AE" />
      <div v-if="getLoading" class="loading-container">
        <img class="loading" src="../../assets/img/loading.svg" alt="loading" />
      </div>
      <div class="header-top-right">
        <div
          class="header-toggle header-search mobile"
          v-if="this.$route.name !== 'inquiry' && this.$route.name !== 'log' && this.$route.name !== 'calendar' && this.$route.name !== 'form76' && this.$route.name !== 'leaveReport' && this.$route.name !== 'salary' && this.$route.name !== 'rates'"
          @click="showInput()"
        >
          <span class="miv">N</span>
        </div>
        <div
          class="search-input-wrapper mobile"
          v-show="isSearchShown == true && this.$route.name !== 'inquiry' && this.$route.name !== 'log' && this.$route.name !== 'calendar'"
        >
          <input
            class="search-input"
            type="text"
            placeholder="Търсене"
            v-model="search"
            ref="searchInputField"
            @keyup="sendSearchInput()"
          />
        </div>
        <div class="header-toggle" v-if="getUser.permissions.isSuperAdmin" @click="goToLog()">
          <span class="miv2">n</span>
          <div class="desktop">
            <p>Активности</p>
          </div>
        </div>

        <div class="vl desktop"></div>
        <div class="header-toggle" v-if="getUser" @click="isUserModalOpened = true">
          <span class="miv">B</span>
          <div class="desktop">
            <p>{{getUser.name}}</p>
          </div>
        </div>
        <div class="vl desktop"></div>
        <span class="header-logout miv" @click="logout()">F</span>
      </div>
    </div>
    <div class="header-bottom">
      <div class="header-bottom-left">
        <router-link
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/calendar/1"
          :class="{
            'header-bottom-tab-active': (
              this.$route.name === 'calendar'
            )
          }"
        >
          <span class="miv2 mobile-inline">F</span>
          <span class="desktop">Календар</span>
          <span class="mobile-text">Календар</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isAdmin || getUser.permissions.isReporter"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          :class="{
            'header-bottom-tab-active': (
              this.$route.name === 'inquiry'
            )
          }"
          to="/inquiry"
        >
          <span class="miv2 mobile-inline">A</span>
          <span class="desktop">Справки</span>
          <span class="mobile-text">Справки</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isAdmin"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/form76"
        >
          <span class="miv2 mobile-inline">j</span>
          <span class="desktop">Форма 76</span>
          <span class="mobile-text">Форма 76</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isAdmin"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/leave-report"
        >
          <span class="miv2 mobile-inline">j</span>
          <span class="desktop">Справка отпуск</span>
          <span class="mobile-text">Отпуск</span>
        </router-link>
        <router-link
          v-if="canAccessPayroll"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          :class="{ 'header-bottom-tab-active': $route.name === 'salary' }"
          to="/salary"
        >
          <span class="miv2 mobile-inline">j</span>
          <span class="desktop">Заплати</span>
          <span class="mobile-text">Заплати</span>
        </router-link>
        <router-link
          v-if="canAccessPayroll"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          :class="{ 'header-bottom-tab-active': $route.name === 'rates' }"
          to="/rates"
        >
          <span class="miv2 mobile-inline">j</span>
          <span class="desktop">Ставки</span>
          <span class="mobile-text">Ставки</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isReporter"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/reports/own"
          :class="{
            'header-bottom-tab-active': (
              this.$route.name === 'newReport' ||
              this.$route.name === 'editReport'
            )
          }"
        >
          <span class="miv2 mobile-inline">B</span>
          <span class="desktop">Отчети</span>
          <span class="mobile-text">Отчети</span>
        </router-link>
        <!-- <router-link class="header-bottom-tab" exact-active-class="header-bottom-tab-active" to="/">Справки по отчети</router-link> -->
        <router-link
          v-if="getUser.permissions.isAdmin"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/companies"
          :class="{
            'header-bottom-tab-active': (
              this.$route.name === 'newCompany' ||
              this.$route.name === 'editCompany' ||
              this.$route.name === 'newProject' ||
              this.$route.name === 'newObject' ||
              this.$route.name === 'newPart' ||
              this.$route.name === 'getPart'
            )
          }"
        >
          <span class="miv2 mobile-inline">C</span>
          <span class="desktop">Фирми</span>
          <span class="mobile-text">Фирми</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isAdmin && $route.name !== 'otpusks'"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/users"
        >
          <span class="miv2 mobile-inline">D</span>
          <span class="desktop">Потребители</span>
          <span class="mobile-text">Потребители</span>
        </router-link>
        <router-link
          v-if="getUser.permissions.isAdmin && $route.name === 'otpusks'"
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active header-bottom-tab-active-green"
          to="/otpusks"
        >
          <span class="miv2 mobile-inline">j</span>
          <span class="desktop">Справка отпуски</span>
          <span class="mobile-text">Отпуски</span>
        </router-link>
      </div>
      <div class="header-bottom-right desktop">
        <div
          class="search-input-wrapper"
          v-if="this.$route.name !== 'inquiry' && this.$route.name !== 'log' && this.$route.name !== 'calendar' && this.$route.name !== 'form76' && this.$route.name !== 'leaveReport' && this.$route.name !== 'salary' && this.$route.name !== 'rates'"
        >
          <input
            class="search-input"
            type="text"
            placeholder="Търсене"
            @keyup="sendSearchInput()"
            v-model="search"
          />
        </div>
      </div>
      <!-- <div class="header-bottom-right ">

      </div>-->
    </div>
    <UserModal v-if="isUserModalOpened" :idToEdit="getUser._id" :limitedFunctionality="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserModal from './UserModal';
export default {
  components: {
    UserModal
  },
  watch: {
    '$route.name'(to) {
      // don't reset search if route is 'newPart' or 'getPart', because that will make
      // a request to get all companies again and will reset the companies dropdown tree
      if (
        to !== 'newPart' &&
        to !== 'getPart' &&
        to !== 'newProject' &&
        to !== 'newObject'
      ) {
        this.search = '';
        this.sendSearchInput();
      }
    }
  },
  data() {
    return {
      isUserModalOpened: false,
      search: '',
      isSearchShown: false
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser',
      'getLoading',
      'canAccessPayroll'
    ])
  },
  methods: {
    goToLog() {
      this.$router.push('/log');
    },
    logout() {
      this.$store
        .dispatch('logout')
        .then(() => this.$router.push('/login'))
        .catch(err => console.log(err));
    },
    // Send searched string globally
    sendSearchInput() {
      this.$root.$emit('sendSearchInput', this.search);
    },
    showInput() {
      this.isSearchShown = !this.isSearchShown;
      if (this.isSearchShown) {
        this.$nextTick(() => {
          this.$refs['searchInputField'].focus();
        });
      }
      this.search = '';
    }
  },
  mounted() {
    this.$on('closeUserModal', result => {
      this.isUserModalOpened = false;
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.$store
          .dispatch('logout')
          .then(() => this.$router.push('/login'))
          .catch(err => console.log(err));
      }
    });
  },
  destroyed() {
    this.$off('closeUserModal');
  }
};
</script>

<style scoped>
.header {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#083f75+0,2d2d2d+100 */
  background: rgb(8, 63, 117); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(8, 63, 117, 1) 0%,
    rgba(45, 45, 45, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(8, 63, 117, 1) 0%,
    rgba(45, 45, 45, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(8, 63, 117, 1) 0%,
    rgba(45, 45, 45, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#083f75', endColorstr='#2d2d2d',GradientType=0 ); /* IE6-9 */
  height: 75px;
  width: 100%;
}
.header-top,
.header-bottom {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 40px;
  width: 100%;
}
.header-bottom {
  align-items: flex-start;
  height: 35px;
}
/* HEADER TOP */
.header-logo {
  height: 28px;
  width: auto;
}
.header-top-right {
  align-items: center;
  display: flex;
}
.header-toggle {
  align-items: center;
  border-radius: 1px;
  cursor: pointer;
  display: flex;
  height: 31px;
  padding: 0 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.header-toggle:hover {
  background-color: rgba(0, 0, 0, 0.15);
}
.header-toggle .miv,
.header-toggle .miv2 {
  color: #fff;
  font-size: 16px;
  margin-right: 10px;
}
.header-toggle p {
  color: #fff;
  font-size: 12px;
}
.header-logout {
  border-radius: 1px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px;
  /* margin: 0 -10px 0 8px; */
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.header-logout:hover {
  background-color: rgba(0, 0, 0, 0.15);
}
/* HEADER BOTTOM */
.header-bottom-left {
  align-items: flex-end;
  display: flex;
  height: 35px;
}
.header-bottom-tab {
  align-items: center;
  background-color: rgba(240, 240, 247, 0.2);
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  color: #fff;
  font-size: 13px;
  display: inline-flex;
  /* height: 45px; */
  justify-content: center;
  margin-right: 3px;
  padding: 6px 15px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  /* width: 150px; */
}
.header-bottom-tab:hover {
  background-color: rgba(240, 240, 247, 0.3);
}
.header-bottom-tab-active {
  background-color: rgba(240, 240, 247, 1);
  color: #000;
}
.header-bottom-tab-active:hover {
  background-color: rgba(240, 240, 247, 1);
}
.header-bottom-tab-active-green,
.header-bottom-tab-active-green:hover {
  background-color: #f0f7f7;
}
.header-bottom-right {
  align-items: center;
  display: flex;
}
.search-input-wrapper {
  height: 31px;
  position: relative;
  width: 250px;
}
.search-input-wrapper::before {
  color: #fff;
  content: 'N';
  font-family: 'miv';
  font-size: 16px;
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.search-input {
  border: none;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 1px;
  caret-color: #fff;
  color: #fff;
  height: 100%;
  padding: 5px 15px 5px 34px;
  width: 100%;
}
.search-input::placeholder {
  color: #fff;
}
.vl {
  background-color: #fff;
  height: 31px;
  opacity: 0.5;
  width: 1px;
}
.mobile,
.mobile-inline,
.mobile-text {
  display: none;
}

/* RESPONSIVE */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .mobile-inline {
    display: inline;
  }
  .header {
    height: auto;
    width: 100%;
  }
  .header-top,
  .header-bottom {
    padding: 0 15px;
    width: 100%;
  }
  .header-bottom-tab {
    flex-direction: column;
    height: 100%;
    padding: 0;
    width: 100%;
  }
  .header-bottom-tab .miv2 {
    font-size: 18px;
  }
  .header-bottom-tab .mobile-text {
    display: inline-block;
    font-size: 8px;
    margin-top: 2px;
  }
  .header-bottom-tab:last-child {
    margin-right: 0;
  }
  .header-top-right {
    justify-content: flex-end;
  }
  .header-bottom-left {
    justify-content: center;
    width: 100%;
  }
  .search-input {
    padding: 5px 15px 5px 5px;
  }
  .search-input-wrapper {
    height: auto;
    margin-left: 5px;
    width: 100%;
  }
  .header-toggle .miv,
  .header-toggle .miv2 {
    margin: 0;
  }
  .header-logout {
    margin: 0px;
  }
  .search-input-wrapper::before {
    display: none;
  }
}

@media print {
  .header {
    display: none;
  }
}
</style>
